import request from '@/utils/request'
import { getToken } from '../utils/auth'

// 上次回访记录
export function querypersoncalllistremark (data) {
  return request({
    url: '/querypersoncalllistremark',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 查询老人回访记录
export function querycalllistremarkbypid (data) {
  return request({
    url: '/querycalllistremarkbypid',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 客服关爱-当月未关爱长者，支持分页
export function queryoldpersonbyoidsanduncall (data) {
  return request({
    url: '/queryoldpersonbyoidsanduncall',
    method: 'post',
    params: { token: getToken(), page: data.page, size: data.size },
    data: {
      oids: data.oids
    }
  })
}
// 客服关爱-日常关爱长者，支持分页
export function queryoldpersongeneraluncall (data) {
  return request({
    url: '/queryoldpersongeneraluncall',
    method: 'post',
    params: { token: getToken(), page: data.page, size: data.size },
    data: {
      oids: data.oids
    }
  })
}
// 客服关爱-特殊关爱长者，支持分页
export function queryoldpersonspecialuncall (data) {
  return request({
    url: '/queryoldpersonspecialuncall',
    method: 'post',
    params: { token: getToken(), page: data.page, size: data.size },
    data: {
      oids: data.oids
    }
  })
}
// {
//   "oids": [], 组织ID，空数组为全部
//   "lessname": "", 人名，空字符串为全部
//   "sex": -1,  性别ID，下拉框选择，-1 为全部
//   "frequency_id": -1,  频率ID，下拉框选择，-1 为全部
//   "project_id": -1 项目ID，下拉框选择，-1 为全部
// }
export function searcholdpersonwithnewtype (data, page, size) {
  return request({
    url: '/searcholdpersonwithnewtype',
    method: 'post',
    params: { token: getToken(), page: page, size: size },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/custormservice.js